import { render, staticRenderFns } from "./SettingsMydata.vue?vue&type=template&id=59ae987b&scoped=true&"
import script from "./SettingsMydata.vue?vue&type=script&lang=ts&"
export * from "./SettingsMydata.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ae987b",
  null
  
)

export default component.exports